import { Divider, Box, Grid } from "@mui/material";
import React from "react";
import VendorContactCard from "../../../stories/VendorContactcard/VendorContactCard";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

export default function VendorContactinformation(props) {

  const { t } = useTranslation();

  return (
    <>
      {/* <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec" className="mt-3" sx={{ padding: "10px", backgroundColor: "#fff" }}>
        <span className="text-muted mx-2 mt-1" style={{fontWeight: "bolder", fontSize:"larger",marginTop:"5px"}}>{t('VendorDetails.label20')}</span>
        <Divider sx={{ backgroundColor: "#667085;", height: "2px" }} />
        <Box sx={{ flexGrow: 1, paddingLeft: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {props?.contact.map((r,i) => (
              <Grid item xs={12} sm={3} md={3} key={i}>
                <VendorContactCard contacts={r} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <br />
      </Box> */}

      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-3"
        sx={{
          padding: "10px",
          backgroundColor: "#fff",
        }}
      >
        <span
          className="text-muted mx-2 mt-1"
          style={{
            fontWeight: "bolder",
            fontSize: "larger",
            marginTop: "5px",
          }}
        >
          {t("VendorDetails.label20")}
        </span>

        <Divider
          sx={{
            backgroundColor: "#667085",
            height: "2px",
          }}
        />

        <Box
          sx={{
            flexGrow: 1,
            paddingLeft: 1,
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            alignItems="stretch"
          >
            {props?.contact?.map((r, i) => (
              <Grid
                item
                xs={12}
                sm={3}
                md={3}
                key={i}
                sx={{
                  display: "flex",
                }}
              >
                <VendorContactCard contacts={r} />
              </Grid>
            ))}
          </Grid>
        </Box>

        <br />
      </Box>
    </>
  )
}